import React from "react";
import { FF } from "../lib/constants";

// Korte melding onderin beeld (niet meer rechtsboven, daar zit nu de topbalk).
export default function SaveBadge({ show, label }) {
  if (!show) return null;
  return <div role="status" style={{ position: "fixed", bottom: 18, left: "50%", transform: "translateX(-50%)", background: "#2F7D47", color: "#fff", padding: "8px 16px", borderRadius: 20, fontSize: 12, fontWeight: 700, zIndex: 999, fontFamily: FF, boxShadow: "0 4px 14px rgba(0,0,0,.18)" }}>{label || "OPGESLAGEN ✓"}</div>;
}
